import { SkillCategory } from 'interface/skill';
import * as Yup from 'yup';

export const addCategorySkillSchema: Yup.ObjectSchema<SkillCategory> = Yup.object({
  name: Yup.string().required('Please provide name').trim().typeError('Please provide name'),

  description: Yup.string().trim().typeError('Please provide description'),
});
